import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { Customer, CustomerAccount } from '@inyova/models';

import { Subject } from 'rxjs';

import { CustomerInvestmentData } from '@shared/models/Strategy';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-portfolio-fees',
  templateUrl: './strategy-portfolio-fees.component.html',
  styleUrls: ['./strategy-portfolio-fees.component.scss'],
  standalone: false
})
export class StrategyPortfolioFeesComponent implements OnChanges {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() investmentData: CustomerInvestmentData;
  @Input() customer: Customer;
  @Input() currentAccount: CustomerAccount;
  monthlyFee = { value: 0, decimal: 0 };

  iconArray = ['cover1', 'cover2', 'cover4', 'cover3'];
  showMore: boolean;
  showFeesNotice = false;
  investmentDetails = [];
  totalInvestment: number;

  constructor(
    private trackingService: TrackingService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const investmentData = this.investmentData;

    const { total } = investmentData;
    let investment = total;

    const yearlyTable = [];

    for (let i = 0; i < 12; i++) {
      const ratio = this.currentAccount.inyova_fee;
      const fee = ((investment / 12) * ratio) / 100;
      yearlyTable.push({ investment, ratio, fee });
      investment += investmentData.monthly_investment;
    }

    this.totalInvestment = investment;

    this.monthlyFee.value = yearlyTable.map((item: { investment: number; ratio: number; fee: number }) => item.fee).reduce((a, b) => a + b) / 12;
    this.monthlyFee.decimal = this.monthlyFee.value > 10 ? 0 : 1;

    this.showFeesNotice =
      !this.customer.inyova_pro && total > 50000 && this.isDateBetween(new Date('2024-01-01'), new Date('2024-07-08'), new Date());

    this.investmentDetails = [
      {
        title: 'new_strategy.portfolio_screen.graph_box.costs.moreII',
        fees: this.investmentData.total
      },
      {
        title: 'new_strategy.portfolio_screen.graph_box.costs.moreSP',
        fees: this.investmentData.monthly_investment
      }
    ];
  }

  trackTooltip(name: string) {
    this.amplitudeService.trackEvent('Tooltip Info Consulted', {
      tooltip_name: name,
      screen: 'Portfolio fees',
      consultation_method: 'hover'
    });
  }

  isDateBetween(startDate: Date, endDate: Date, currentDate: Date) {
    return startDate <= currentDate && currentDate < endDate;
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
    this.trackingService.trackActivity(`[Button] Fee details: Show ${this.showMore ? 'more' : 'less'}`);
    if (this.showMore) {
      this.amplitudeService.trackEvent('Tooltip Info Consulted', {
        tooltip_name: 'fee details',
        screen: 'Portfolio fees',
        consultation_method: 'click'
      });
    }
  }

  trackActivity(activity: string): void {
    this.trackingService.trackActivity(activity);
  }
}
